module.exports = __webpack_public_path__ + "img/视频封面29.9faf57d5.png";